import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageHeader, LoadingBlock } from "@/components/Common";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid, Legend } from "recharts";
import { Chart } from "@/components/Chart";
import { Sparkles } from "lucide-react";

export default function FoodWaste() {
    const [history, setHistory] = useState(null);
    const [forecast, setForecast] = useState(null);

    useEffect(() => {
        api.get("/foodwaste/history").then((r) => setHistory(r.data));
        api.get("/foodwaste/forecast").then((r) => setForecast(r.data));
    }, []);

    if (!history || !forecast) return <LoadingBlock rows={6} />;

    const recent = history.slice(-14);

    return (
        <>
            <PageHeader
                title="Food Waste Forecast"
                subtitle="Historical waste with AI-generated insights to reduce overproduction."
            />
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-5">
                <Card>
                    <CardHeader className="pb-1"><CardTitle className="text-base">Last 14 days (kg)</CardTitle></CardHeader>
                    <CardContent>
                        <Chart height={288}>
                            <BarChart data={recent}>
                                <CartesianGrid stroke="hsl(var(--border))" strokeDasharray="3 3" />
                                <XAxis dataKey="date" tickFormatter={(v) => v.slice(5)} tick={{ fontSize: 11 }} />
                                <YAxis tick={{ fontSize: 11 }} width={32} />
                                <Tooltip contentStyle={{ background: "hsl(var(--card))", border: "1px solid hsl(var(--border))", borderRadius: 8 }} />
                                <Legend />
                                <Bar dataKey="breakfast" fill="hsl(var(--chart-1))" />
                                <Bar dataKey="lunch" fill="hsl(var(--chart-2))" />
                                <Bar dataKey="dinner" fill="hsl(var(--chart-4))" />
                            </BarChart>
                        </Chart>
                    </CardContent>
                </Card>

                <Card>
                    <CardHeader className="pb-1"><CardTitle className="text-base">Next 7 days forecast</CardTitle></CardHeader>
                    <CardContent>
                        <Chart height={288}>
                            <BarChart data={forecast.forecast}>
                                <CartesianGrid stroke="hsl(var(--border))" strokeDasharray="3 3" />
                                <XAxis dataKey="date" tickFormatter={(v) => v.slice(5)} tick={{ fontSize: 11 }} />
                                <YAxis tick={{ fontSize: 11 }} width={32} />
                                <Tooltip contentStyle={{ background: "hsl(var(--card))", border: "1px solid hsl(var(--border))", borderRadius: 8 }} />
                                <Legend />
                                <Bar dataKey="breakfast" fill="hsl(var(--chart-1))" />
                                <Bar dataKey="lunch" fill="hsl(var(--chart-2))" />
                                <Bar dataKey="dinner" fill="hsl(var(--chart-4))" />
                            </BarChart>
                        </Chart>
                    </CardContent>
                </Card>
            </div>

            <Card>
                <CardContent className="py-4">
                    <div className="flex items-start gap-3" data-testid="foodwaste-insight">
                        <div className="w-8 h-8 rounded-lg bg-[hsl(var(--accent))] grid place-items-center">
                            <Sparkles className="w-4 h-4" />
                        </div>
                        <div>
                            <div className="text-xs uppercase tracking-wider text-muted-foreground mb-1">
                                AI insight
                            </div>
                            <div className="text-sm">{forecast.insight}</div>
                        </div>
                    </div>
                </CardContent>
            </Card>
        </>
    );
}
